// client/src/components/Task/Task.component.tsx
import { memo } from "react";
import { FiEdit } from "react-icons/fi";
import { AiOutlineDelete } from "react-icons/ai";
import { TbFileInvoice } from "react-icons/tb";

import { COFFRET } from "../../api/coffrets";
import { PrintValue } from "../Commons";

import "react-medium-image-zoom/dist/styles.css";
import "./style.scss";

type PropsType = {
  coffret: COFFRET;
  updateTask: (task: COFFRET) => Promise<void>;
  setOpenDeleteModal: React.Dispatch<React.SetStateAction<boolean>>;

  onExportPdf: () => Promise<void>;
  onDownloadInvoice: (coffret: COFFRET) => Promise<void>;
  onExportOneCsv: (coffret: COFFRET) => Promise<void>;
  pdfBusy?: boolean;
};

// Affichage tolérant : si la facture est absente/vidée => “SANS”
const displayFacture = (v?: string) => {
  const s = (v ?? "").trim();
  return s ? s : "SANS";
};

const Task = ({
  coffret,
  updateTask,
  setOpenDeleteModal,
  onExportPdf,
  onDownloadInvoice,
  onExportOneCsv,
  pdfBusy,
}: PropsType) => {
  const imgUrl = `/api/image/hd/${coffret.numeroCoffret}-HD.jpg`;

  const imgUrlHd = () => {
    fetch(`/api/image/hd/${coffret.numeroCoffret}-HD.jpg`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "image/jpeg",
      },
    })
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        window.open(url, "_blank");
      })
      .catch((err) => console.error(err));
  };

  return (
    <li className="task-item">
      <div className="block-title">
        <span>
          {coffret.genre} - {coffret.espece}
          <span>
            ({coffret.quantite}) <span>{coffret.numeroOrdre}</span>
          </span>
        </span>

        {/* Edit */}
        <button onClick={() => updateTask(coffret)}>
          <FiEdit />
        </button>

        {/* Facture (PDF) */}
        <button
          style={{ position: "relative", zIndex: 20, pointerEvents: "auto" }}
          onClick={() => {
            console.log("CLICK FACTURE", coffret);
            onDownloadInvoice(coffret);
          }}
          title="Télécharger la facture"
        >
          <TbFileInvoice />
        </button>

        {/* PDF Spécimen (stylé) */}
        <button onClick={onExportPdf} disabled={!!pdfBusy} title="Exporter ce spécimen en PDF">
          {pdfBusy ? "PDF…" : "PDF"}
        </button>

        {/* CSV unitaire = append seulement */}
        <button onClick={() => onExportOneCsv(coffret)} title="Ajouter ce spécimen à ETIQUETTES">
          CSV↧
        </button>

        {/* Supprimer */}
        <button onClick={() => setOpenDeleteModal(true)}>
          <AiOutlineDelete />
        </button>
      </div>

      <div className="content">
        <div className="block-img">
          <img src={imgUrl} loading="lazy" alt="" onClick={imgUrlHd} />
        </div>
        <span className="infos">
          <span>
            <PrintValue label="type" value={coffret.type} />
            <PrintValue label="faune" value={coffret.faune} />
            <PrintValue label="sexe" value={coffret.sexe} />
          </span>
          <span>
            <PrintValue label="emplacement" value={coffret.emplacement} />
            <PrintValue label="date" value={coffret.dateCapture?.toUpperCase()} />
            <PrintValue label="N°&nbsp;coffret" value={coffret.numeroCoffret} />
          </span>
          <span>
            <PrintValue label="Type&nbsp;d'achat" value={coffret.typeAchat} />
            <PrintValue label="Valeur" value={coffret.prixAchat} />
            <PrintValue label="N°&nbsp;facture" value={displayFacture(coffret.numeroFacture)} />
          </span>
        </span>
      </div>

      <div>
        <PrintValue label="Détails&nbsp;capture" value={coffret.detailsCapture?.toUpperCase()} />
        <PrintValue label="Détails&nbsp;d'achat" value={coffret.detailsAchat?.toUpperCase()} />
        <PrintValue label="Cites" value={coffret.cites?.toUpperCase()} />
      </div>
    </li>
  );
};

export const MemoizedTasks = memo(Task);